import { string, object, array, date } from 'yup'

export const LIMIT = {
  maxPrivateTitleLength: 50,
  maxPublicTitleLength: 50,
  maxAdvertisementContentLength: 350,
  maxSignatureLength: 50
}

const contentSchema = (t) => object().shape(
  {
    language: string().nullable().required(t('ui_elements.require_field')),
    header: string()
      .required(t('ui_elements.required_field'))
      .max(
        LIMIT.maxPublicTitleLength,
        t('advertisements.edition.errors.max_size', {
          max: LIMIT.maxPublicTitleLength,
        }),
      )
      .when(['body'], {
        is: (ac) => !!ac,
        then: (schema) => schema.required(t('ui_elements.required_field')),
        otherwise: (schema) => schema.notRequired()
      }),
    body: string()
      .max(
        LIMIT.maxAdvertisementContentLength,
        t('advertisements.edition.errors.max_size', {
          max: LIMIT.maxAdvertisementContentLength,
        }),
      )
      .when(['header'], {
        is: (pt) => !!pt,
        then: (schema) => schema.required(t('ui_elements.required_field')),
        otherwise: (schema) => schema.notRequired()
      }),
    footer: string()
      .max(
        LIMIT.maxSignatureLength,
        t('advertisements.edition.errors.max_size', {
          max: LIMIT.maxSignatureLength,
        }),
      )
  },
  [
    ['header', 'body'],
  ],
)
const buildSchema = (t) =>
  object().shape({
    accounts: array().of(string()).min(1).required(),
    image: object().nullable().shape({
      dataURL: string().required(),
      name: string()
    }),
    contentCompleted: string()
      .when(['contents'], {
        is: (values) => {
          return values.some(({header, body}) => header.length > 0 || body.length > 0)
        },
        then: (schema) => {
          return schema.notRequired()
        },
        otherwise: (schema) => {
          return schema.required(t('ui_elements.required_field'))
        }
      }).nullable(),
    name: string()
      .max(
        LIMIT.maxPrivateTitleLength,
        t('advertisements.edition.errors.max_size', {
          max: LIMIT.maxPrivateTitleLength,
        }),
      )
      .required(t('advertisements.edition.errors.private_title')),
    starts_at: date()
      .nullable()
      .transform((curr, orig) => orig === '' ? null : curr)
      .required(t('advertisements.edition.errors.invalid_start_date')),
    ends_at: date()
      .nullable()
      .transform((curr, orig) => orig === '' ? null : curr)
      .required(t('advertisements.edition.errors.invalid_end_date')),
    contents: array()
      .of(
        contentSchema(t, t('ui_elements.required_field'))
      )
  })

export default buildSchema
